document.addEventListener("DOMContentLoaded", function () {
  // ----------------------------
  // Helpers
  // ----------------------------
  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist") || "[]");
  }
  function saveWishlist(list) {
    localStorage.setItem("wishlist", JSON.stringify(list));
  }

  // ----------------------------
  // Update Button State
  // ----------------------------
  function updateButton(btn, isAdded) {
    const svg = btn.querySelector("svg");
    if (!svg) return;
    if (isAdded) {
      svg.innerHTML =
        '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor" stroke="currentColor" stroke-width="2"/>';
      btn.style.color = "#e74c3c";
    } else {
      svg.innerHTML =
        '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="2"/>';
      btn.style.color = "#666";
    }
  }

  // ----------------------------
  // Toggle Wishlist
  // ----------------------------
  function toggleWishlist(btn) {
    const productId = btn.dataset.productId;
    const list = getWishlist();
    const index = list.findIndex((item) => item.id === productId);

    if (index > -1) {
      list.splice(index, 1);
      updateButton(btn, false);
      showPopup("Removed from wishlist");
    } else {
      const data = {
        id: productId,
        title: btn.dataset.productTitle,
        handle: btn.dataset.productHandle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        url: btn.dataset.productUrl,
        vendor: btn.dataset.productVendor,
        fragrance: btn.dataset.productFragrance || "",
        variantId: btn.dataset.variantId,
        available: btn.dataset.variantAvailable === "true"
      };
      list.push(data);
      updateButton(btn, true);
      showPopup("Added to wishlist");
    }

    saveWishlist(list);
  }

  // ----------------------------
  // Initialize wishlist buttons
  // ----------------------------
  function initWishlistButtons(context = document) {
    const list = getWishlist();

    context.querySelectorAll(".wishlist-btn").forEach((btn) => {
      if (btn.dataset.bound === "true") return;
      btn.dataset.bound = "true";

      const isAdded = list.some((item) => item.id == btn.dataset.productId);
      updateButton(btn, isAdded);

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(btn);
      });
    });
  }

  // ----------------------------
  // Display Wishlist Page
  // ----------------------------
  function displayWishlist() {
    const container = document.getElementById("wishlist-container");
    if (!container) return;

    const list = getWishlist();
    if (!list.length) {
      container.innerHTML =
        '<p class="wishlist-empty">Your wishlist is empty. <a href="/collections/all">Start shopping</a>.</p>';
      return;
    }

    container.innerHTML =
      '<div class="wishlist-grid">' +
      list
        .map(
          (item) => `
          <div class="wishlist-item">
            <a href="${item.url}" style="text-decoration:none;color:inherit">
              <div class="wishlist-product-img"><img src="${item.image}" alt="${item.title}"></div>
              <h3>${item.title}</h3>
              
              <!--div class="caption-with-letter-spacing light">${item.vendor}</div-->

              ${
                item.fragrance
                  ? `<div class="caption-with-letter-spacing light">${item.fragrance}</div>`
                  : ""
              }

              <p>${item.price}</p>
            </a>
            <div class="wishlist-cta-btn">
            <!--button onclick="addToCartFromWishlist('${item.variantId}')" class="wishlist-cta-btn-add">Add</button-->
              ${
                item.available
                  ? `<button onclick="addToCartFromWishlist('${item.variantId}')" class="wishlist-cta-btn-add">Add</button>`
                  : `<button class="wishlist-cta-btn-soldout" disabled>Sold Out</button>`
              }
              <button onclick="removeFromWishlist('${item.id}')" class="wishlist-cta-btn-remove">
                <span class="svg-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16">
                    <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path>
                    <path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>`
        )
        .join("") +
      "</div>";
  }

  // ----------------------------
  // Add to Cart from Wishlist (UPDATED FOR CRAFT)
  // ----------------------------
  window.addToCartFromWishlist = function (variantId) {
    showPopup("Adding to cart...");
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(() => {
        return Promise.all([
          fetch(`/?section_id=cart-drawer`).then(res => res.text()),
          fetch(`/?section_id=header`).then(res => res.text()),
          fetch("/cart.js").then(res => res.json())
        ]);
      })
      .then(([drawerHtml, headerHtml, cart]) => {
        // Update cart drawer
        const parser = new DOMParser();
        const drawerDoc = parser.parseFromString(drawerHtml, "text/html");
        const freshDrawer = drawerDoc.querySelector("cart-drawer");
        const currentDrawer = document.querySelector("cart-drawer");
        
        if (freshDrawer && currentDrawer) {
          currentDrawer.replaceWith(freshDrawer);
          
          const newDrawer = document.querySelector("cart-drawer");
          if (newDrawer && typeof newDrawer.open === "function") {
            newDrawer.open();
          }
        }
        
        // Update cart icon from fresh header HTML
        const headerDoc = parser.parseFromString(headerHtml, "text/html");
        const freshCartIcon = headerDoc.querySelector("#cart-icon-bubble");
        const currentCartIcon = document.querySelector("#cart-icon-bubble");
        
        if (freshCartIcon && currentCartIcon) {
          // Replace the entire cart icon element with the fresh one
          currentCartIcon.innerHTML = freshCartIcon.innerHTML;
        }
        
        showPopup("Item added to cart");
      })
      .catch((err) => {
        console.error("Add to cart error:", err);
        showPopup("Failed to add to cart");
      });
  };


  // ----------------------------
  // Remove from Wishlist
  // ----------------------------
  window.removeFromWishlist = function (productId) {
    let list = getWishlist();
    list = list.filter((item) => item.id != productId);
    saveWishlist(list);
    displayWishlist();
    showPopup("Removed from wishlist");
  };

  // ----------------------------
  // Popup Notification
  // ----------------------------
  function showPopup(message) {
    let popup = document.getElementById("wishlist-popup");
    if (!popup) {
      popup = document.createElement("div");
      popup.id = "wishlist-popup";
      popup.style.position = "fixed";
      popup.style.bottom = "25px";
      popup.style.left = "50%";
      popup.style.transform = "translateX(-50%)";
      popup.style.background = "#333";
      popup.style.color = "#fff";
      popup.style.padding = "10px 18px";
      popup.style.borderRadius = "4px";
      popup.style.fontSize = "14px";
      popup.style.opacity = "0";
      popup.style.transition = "opacity 0.3s ease, bottom 0.3s ease";
      popup.style.zIndex = "9999";
      document.body.appendChild(popup);
    }

    popup.textContent = message;
    popup.style.opacity = "1";
    popup.style.bottom = "40px";

    setTimeout(() => {
      popup.style.opacity = "0";
      popup.style.bottom = "25px";
    }, 2000);
  }

  // ----------------------------
  // Mutation Observer (for dynamically loaded buttons)
  // ----------------------------
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            (node.matches(".wishlist-btn") ||
              node.querySelector(".wishlist-btn"))
          ) {
            initWishlistButtons(node);
          }
        });
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ----------------------------
  // Run initializers
  // ----------------------------
  initWishlistButtons();

  if (window.location.pathname.includes("/pages/wishlist")) {
    displayWishlist();
  }
});
